










































































  import Vue from 'vue';
import Component from 'vue-class-component';
  
  @Component
  export default class PlaygroundRadioButtonWrapper extends Vue {
    public state: string = 'error';
    public label: string = 'show';
  }
